module.exports = __webpack_public_path__ + "img/image002.fff5de3f.jpg";